// src/components/PanoramaViewer.tsx
import React, { useEffect, useRef } from 'react';
import { Viewer } from '@photo-sphere-viewer/core';
import { AutorotatePlugin } from '@photo-sphere-viewer/autorotate-plugin';
import '@photo-sphere-viewer/core/index.css';

const panoramaImages = [
  { title: 'Obývací pokoj', path: '/images/obyvak.webp' },
  { title: 'Kuchyň', path: '/images/kuchyn.webp' },
  { title: 'Ložnice 1', path: '/images/loznice1.webp' },
  { title: 'Ložnice 2', path: '/images/loznice2.webp' },
  { title: 'Ložnice 2 - 1', path: '/images/loznice_1_1.webp' },
  { title: 'Chodba', path: '/images/chodba.webp' },
  { title: 'Koupelna', path: '/images/koupelna.webp' },
];

const isMobile = () =>
  typeof window !== 'undefined' &&
  /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

interface AutorotatePluginInstance {
  start: () => void;
}

const SinglePanoramaViewer: React.FC<{ image: string }> = ({ image }) => {
  const viewerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!viewerRef.current) return;

    const viewer = new Viewer({
      container: viewerRef.current,
      panorama: image,
      plugins: [[AutorotatePlugin, { autorotateSpeed: '1rpm' }]],
      navbar: ['zoom', 'fullscreen', 'autorotate', 'download'],
    });

    const autorotate = viewer.getPlugin(AutorotatePlugin) as unknown as AutorotatePluginInstance;
    if (autorotate && typeof autorotate.start === 'function') {
      setTimeout(() => autorotate.start(), 500);
    }

    return () => {
      viewer.destroy();
    };
  }, [image]);

  return (
    <div className="w-full h-64 sm:h-80 md:h-96 lg:h-[400px]">
      <div ref={viewerRef} className="w-full h-full" />
    </div>
  );
};

const PanoramaViewer: React.FC = () => {
  const handleClick = (image: string) => {
    if (isMobile()) {
      const encoded = encodeURIComponent(image);
      window.location.href = `/mobile-panorama?image=${encoded}`;
    }
  };

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 pb-12">
      {panoramaImages.map((panorama, index) => (
        <div
          key={index}
          className="bg-white shadow-lg rounded-lg overflow-hidden cursor-pointer"
          onClick={() => handleClick(panorama.path)}
        >
          <h3 className="text-lg font-semibold text-center text-[#4B2E2E] py-3">
            {panorama.title}
          </h3>
          {!isMobile() && <SinglePanoramaViewer image={panorama.path} />}
        </div>
      ))}
    </div>
  );
};

export default PanoramaViewer;
